import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { sanitizeHTML } from 'src/app/core/helpers/text-sanitizer';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { translate } from 'src/app/project/features/translate/translate';
import { TranslationPipe } from 'src/app/project/features/translate/translation.pipe';
import { GET_CUSTOM_FIELDS } from 'src/app/project/modules/custom-fields/custom-fields.store';
import { WorkspaceService } from 'src/app/project/modules/workspace/workspace.service';

@Component({
  selector: 'pp-advanced-filter-option-select',
  templateUrl: './advanced-filter-option-select.component.html',
  styleUrls: ['./advanced-filter-option-select.component.scss'],
  standalone: false,
})
export class AdvancedFilterOptionSelectComponent {
  @Input()
  ppItems: TSelectOption[];
  @Input() ppClass: string;
  @Input() ppOption: any;
  @Input() ppShowFieldTooltips: boolean;
  @Input() ppWidth: string;
  ppNoSearchBar = input<boolean>(true);

  @Output() ppOptionChange = new EventEmitter<TSelectOption>();

  selectedOption: TSelectOption;
  items: TSelectOption[];

  constructor(
    private translationPipe: TranslationPipe,
    private workspaceService: WorkspaceService,
  ) {}

  ngOnChanges(): void {
    this.items = this.transformToListItem(this.ppItems);
    this.findSelectedOption();
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.ppOption = newCondition.value;
    this.findSelectedOption();
    this.onOptionChanged(newCondition);
  }

  findSelectedOption(): void {
    this.selectedOption = this.items.find((item) => item.value === this.ppOption);
  }

  onOptionChanged(newCondition: TSelectOption): void {
    this.ppOptionChange.emit(newCondition);
  }

  transformToListItem(items: TSelectOption[]): TSelectOption[] {
    return items.map((item) => {
      if (!this.ppShowFieldTooltips) {
        return {
          ...item,
          label: item?.translationKey
            ? `${translate(item.translationKey)}${item.suffix}`
            : item.label,
        };
      } else {
        return {
          ...item,
          tooltip: this.getItemTooltip(item.customFields),
        };
      }
    });
  }

  private getItemTooltip(customFields: string[]): string {
    if (!customFields || customFields.length === 0) {
      return '';
    }

    let tooltip = `
      <div style='text-align: left; margin-top: 0.625rem'>
      ${this.translationPipe.transform('custom_field_used_on_sites')}
      <ul>`;

    customFields.forEach((customFieldId) => {
      const customField = GET_CUSTOM_FIELDS()[customFieldId];
      const workspace = this.workspaceService.getWorkspace(customField.workspaceId);

      tooltip +=
        '<li>•	<strong>' +
        sanitizeHTML(workspace.accountName) +
        '</strong> - ' +
        sanitizeHTML(workspace.siteName) +
        '</li>';
    });

    tooltip += `
        </ul>
      </div>
    `;

    return tooltip;
  }
}
